<h1 class='title'>Log in</h1>
<app-login-form (formSubmit)='login($event)' [loading]='auth.loading' [errors]='auth.errors$'></app-login-form>
